import axios from 'axios';
import {
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardText,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext,  useEffect,  useState } from 'react';
import EmailFormModal from './EmailFormModal';
import { UserProfileContext } from '../context/UserProfileProvider';

const EmailCard = ({email, emailsId, setActiveTab, activeTab, setShowEmailModal, setEmailToUpdate,  isCheckout, isDelete}) => {
    const {setEmails,emails} = useContext(UserProfileContext); 
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    useEffect(() => {
        if (emails.length > 0) {
            setActiveTab(emails[0].type);
        }
    }, [emails, setActiveTab]);
    const handleDelete = () => {
        axios({
            method: 'delete',
            url: `${baseUrl}/emails/${emailsId}`,
            data: Array.from([email.id])
        })
        .then(response => {
            if(response.status === 200) {
                setEmails(prevEmails => {
                    const updatedEmails = prevEmails.filter(eml => eml.id !== email.id);
                    if (updatedEmails.length > 0) {
                        if(activeTab === email.type) setActiveTab(updatedEmails[0].type);   
                    }else{
                        axios.delete(`${baseUrl}/emails/all/${emailsId}`)
                        .then(response => {
                            setEmails([]);
                            setEmailToUpdate([]);
                           
                        })
                        .catch(err => {
                            console.error("An error occurred while deleting the addressesId", err);
                        });                
                    }    
                    return updatedEmails;
                });
            }
        })
        .catch(err => console.error(err));
    };
    const handleUpdate = useCallback(() => {
        setShowEmailModal(true);
        setEmailToUpdate(email);
    }, [email, setEmailToUpdate, setShowEmailModal]);

    return (
        <MDBCard >
            <MDBCardBody>
                <MDBCardText>{email.value}</MDBCardText>
            </MDBCardBody>           

            <MDBBtnGroup className='mb-2 mx-2'> 
            <MDBBtn color='primary' className='me-2 mt-2' onClick={handleUpdate}>Update</MDBBtn>
           {isDelete &&  <MDBBtn color='success' className='me-2 mt-2' onClick={handleDelete}>Delete</MDBBtn> }
           <MDBBtn  className='mt-2' color='warning' onClick={() => setShowEmailModal(true)}>ADD New  Email </MDBBtn>
            </MDBBtnGroup>
          {isCheckout &&  <MDBCol md="2" >
            <MDBSwitch md-5 id='billing' label='Select' />
            </MDBCol>}

     
        </MDBCard>
    );
};

EmailCard.propTypes = {
    isCheckout: PropTypes.bool,
    email: PropTypes.array,   
    emailsId: PropTypes.string,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.string,
    setShowEmailModal: PropTypes.func,  
    setEmailToUpdate: PropTypes.func,   
    isDelete: PropTypes.bool,
}


function EmailView({ isCheckout}) {
    const {setEmails, emails } = useContext(UserProfileContext); 
    const [activeTab, setActiveTab] = useState(emails && emails[0] && emails[0].type);
    const [emailToUpdate, setEmailToUpdate] = useState(null);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
   


    const handleTabChange = (type) => {
        setActiveTab(type);
    }

    return (
        <MDBCol >
            <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}> Email </h5>
            <hr className="hr" />
 
        <MDBCardHeader background="light" className="text-center rounded">
                <MDBTabs className='card-header-tabs'>
                    {Array.isArray(emails) ? emails?.map((email, index) => (
                        <MDBTabsItem key={index}>
                            <MDBTabsLink active={activeTab === email.type} onClick={() => handleTabChange(email?.type)}>
                                {email?.type}
                            </MDBTabsLink>
                        </MDBTabsItem>
                    )): null}
                </MDBTabs>
            </MDBCardHeader>
      
                <MDBRow className='justify-content-center'>
                    {Array.isArray(emails) ? emails?.map((email, index) => (
                        activeTab === email.type && (
                            <MDBCol  className='mb-4' key={index}>
                                <EmailCard isCheckout={isCheckout} key={email.id}
                                    email={email} 
                                    setActiveTab={setActiveTab}
                                    activeTab={activeTab}
                                    setShowEmailModal={setShowEmailModal} 
                                    setEmailToUpdate={setEmailToUpdate}
                                    isDelete={emails?.length>1}
                                />
                            </MDBCol>
                        )
                    )) : null}
                </MDBRow>
               
{showEmailModal && 
        <EmailFormModal 
            baseUrl={baseUrl} 
            showEmailModal={showEmailModal}
            setShowEmailModal={setShowEmailModal}          
            setEmails={setEmails}
            emails={emails}
            emailToUpdate={emailToUpdate}
        />}
        </MDBCol>
    );
}

EmailView.propTypes = {
    isCheckout: PropTypes.bool
    
}

export default EmailView;
